import DOMPurify from 'dompurify';

export const sanitizeData = (data) => {
  if (!data) return data;

  if (typeof data === 'string') {
    return DOMPurify.sanitize(data);
  }

  if (data instanceof FormData) {
    // Don't sanitize FormData objects
    return data;
  }

  if (typeof data === 'object') {
    const sanitizedData = {};
    for (const [key, value] of Object.entries(data)) {
      sanitizedData[key] = sanitizeData(value);
    }
    return sanitizedData;
  }

  return data;
}; 